export const createConstants = (...constants: string[]): { [key: string]: string } =>
  constants.reduce((acc, constant) => {
    acc[constant] = constant;
    return acc;
  }, {} as { [key: string]: string });
